// import _ from "lodash";
// import { getCookie, removeAllCookies, setCookie } from "../../utils/cookies";
// import { axiosClient } from "../client";
// import firebase from "firebase";
// import axios from "axios";
import _ from "lodash";
import { getCookie, setCookie } from "../../utils/cookies";
import { axiosClient } from "../client";
import axios from "axios";

// const AUTH_ENDPOINT = `${process.env.REACT_APP_API_PRESTO_EXPRESS_ACCOUNTS}/account/add`;
const REFRESH_TOKEN_ENDPOINT = `${process.env.REACT_APP_API_PRESTO_EXPRESS_ACCOUNTS}/account/session`;

const ACCOUNT_ID_TOKEN_ENDPOINT = `${process.env.REACT_APP_API_PRESTO_EXPRESS_ACCOUNTS}/account/token`;
// const API_FIREBASE_AUTH_REFRESH_TOKEN = `https://securetoken.googleapis.com/v1/token?key=${process.env.REACT_APP_FIREBASE_AUTH_API_KEY}`;

// export const authenticateTokenWithServer = (data) => {
//   return axiosClient({
//     url: AUTH_ENDPOINT,
//     method: "POST",
//     data,
//   });
// };

export const checkRefreshTokenWithServer = (data) => {
  return axiosClient({
    url: REFRESH_TOKEN_ENDPOINT,
    method: "POST",
    data,
    withCredentials: true,
  });
};

// export const getAccountIdToken = async () => {
//   try {
//     const response = await axios.get(
//       'https://dev.api.account.prestoexpress.co.uk/account/token',
//       {
//         withCredentials: true, // ✅ Send cookies with the request
//       }
//     );
//     return response;
//   } catch (error) {
//     console.error('Failed to get account ID token:', error);
//     return null;
//   }
// };

// export const refreshAccessToken = async () => {
//   try {
//     const res = getAccountIdToken();
//     const { idToken } = res?.data;
//     // const firebaseUser = getCookie("firebaseUser");
//     // await verifyAuthTokenWithServer(
//     //   id_token,
//     //   JSON.parse(firebaseUser),
//     // );
//     // return { id_token, refresh_token };
//   } catch (error) {
//     // return { id_token: "", refresh_token: "" };
//   }
// };

// export const verifyAuthTokenWithServer = async (idToken, firebaseUser) => {
//   const {
//     uid,
//     extId,
//     displayName,
//     name,
//     photoURL,
//     email,
//     emailVerified,
//     isEmailVerified,
//     profilePic,
//   } = firebaseUser;
//   let data = {};
//   if (!_.isEmpty(uid)) {
//     data = {
//       extId: uid,
//       name: displayName || name,
//       email: email,
//       isActive: true,
//       isEmailVerified: emailVerified || isEmailVerified,
//       issuer: "firebase",
//       profilePic: photoURL || profilePic,
//       isAuthenticated: true,
//     };
//   }
//   if (!_.isEmpty(extId)) {
//     data = {
//       extId: extId,
//       name: displayName || name,
//       email: email,
//       isActive: true,
//       isEmailVerified: emailVerified || isEmailVerified,
//       issuer: "firebase",
//       profilePic: photoURL || profilePic,
//       isAuthenticated: true,
//     };
//   }

//   if (!data.extId) return;

//   setCookie("firebaseUser", data, {
//     domain: process.env.REACT_APP_ALLOWED_DOMAIN,
//   });
//   setCookie("idToken", idToken, {
//     domain: process.env.REACT_APP_ALLOWED_DOMAIN,
//   });
// };

const GET_CUSTOM_TOKEN = `${process.env.REACT_APP_API_PRESTO_EXPRESS_GLOBAL}/create_custom_token`;
const AUTH_ENDPOINT = `${process.env.REACT_APP_API_PRESTO_EXPRESS_ACCOUNTS}/account/add`;
const API_FIREBASE_AUTH_REFRESH_TOKEN = `https://securetoken.googleapis.com/v1/token?key=${process.env.REACT_APP_FIREBASE_AUTH_API_KEY}`;

export function getCustomerValidationNew(token) {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_PRESTO_EXPRESS_CUSTOMER}/public-auth/customer/marketing`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function customerUpdateNew(token, firstName, lastName) {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_PRESTO_EXPRESS_CUSTOMER}/public-auth/customer/get-or-create/${firstName}/${lastName}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const getCustomToken = (data) => {
  return axiosClient({
    url: GET_CUSTOM_TOKEN,
    method: "POST",
    headers: {
      Authorization: `Bearer ${data.idToken}`,
    },
  });
};

export const authenticateTokenWithServer = (data) => {
  return axiosClient({
    url: AUTH_ENDPOINT,
    method: "POST",
    data,
  });
};

export const refreshAccountToken = async () => {
  try {
    const res = await axios.get(
      "https://dev.api.account.prestoexpress.co.uk/account/token",
      {
        withCredentials: true,
      },
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const refreshAccessToken = async (refreshToken) => {
  try {
    const {
      data: { id_token, refresh_token },
    } = await axiosClient({
      url: API_FIREBASE_AUTH_REFRESH_TOKEN,
      method: "POST",
      data: {
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      },
    });
    const firebaseUser = getCookie("firebaseUser");
    await verifyAuthTokenWithServer(id_token, JSON.parse(firebaseUser));
    return { id_token, refresh_token };
  } catch (error) {
    return { id_token: "", refresh_token: "" };
  }
};

export const verifyAuthTokenWithServer = async (idToken, firebaseUser) => {
  const {
    uid,
    extId,
    displayName,
    name,
    photoURL,
    email,
    emailVerified,
    isEmailVerified,
    profilePic,
  } = firebaseUser;
  let data = {};
  if (!_.isEmpty(uid)) {
    data = {
      extId: uid,
      name: displayName || name,
      email: email,
      isActive: true,
      isEmailVerified: emailVerified || isEmailVerified,
      issuer: "firebase",
      profilePic: photoURL || profilePic,
      isAuthenticated: true,
    };
  }
  if (!_.isEmpty(extId)) {
    data = {
      extId: extId,
      name: displayName || name,
      email: email,
      isActive: true,
      isEmailVerified: emailVerified || isEmailVerified,
      issuer: "firebase",
      profilePic: photoURL || profilePic,
      isAuthenticated: true,
    };
  }

  if (!data.extId) return;

  setCookie("firebaseUser", data, {
    domain: process.env.REACT_APP_ALLOWED_DOMAIN,
  });
  setCookie("idToken", idToken, {
    domain: process.env.REACT_APP_ALLOWED_DOMAIN,
  });

  await authenticateTokenWithServer(data);
};
